import { Injectable } from '@angular/core';
import { CommonService } from '../core/services/common.service';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { appConfig } from '../app.config';
import { environment } from '@/environments/environment';

@Injectable({ providedIn: 'root' })
export class CommonDataStorage {
  public countryStoreData: any;
  public currencyStoreData: any;
  public languageStoreData: any;
  public companyDetailStoreData: any
  public customerStoreData: any
  public employeeStoreData: any
  public supplierStoreData: any
  private config: any = appConfig;
	public accessGroupListSubject = new BehaviorSubject<string[]>([]);


  constructor(public commonService: CommonService) { }

  getAllData(): void {
    this.commonService.get('list').subscribe((resp: any) => { this.employeeStoreData = resp; })
    this.commonService.get('customer').subscribe((resp: any) => { this.customerStoreData = resp; });
    this.commonService.get('country').subscribe((resp: any) => { this.countryStoreData = resp; });
    this.commonService.get('language').subscribe((resp: any) => { this.languageStoreData = resp; });
    this.commonService.get('currency').subscribe((resp: any) => { this.currencyStoreData = resp.sort((a: any, b: any) => { return (a['currency_name'] > b['currency_name']) ? 1 : -1 }); });
    this.commonService.get('supplier').subscribe((resp: any) => { this.supplierStoreData = resp })
    if (environment.isKrimans) return;
    this.commonService.get('company-detail').subscribe((resp: any) => { this.companyDetailStoreData = resp; });
  }

  permission(){
    this.commonService.get('emp-permission-get').subscribe((resp: any) => { this.accessGroupListSubject.next(resp) });
    if (environment.isKrimans) return;
  }

  getTaxType(currency: number, taxVatNo: string, country?: any) {
    if (currency === 62 && country == 110) {
      if (!taxVatNo) {
        return this.config.taxType['SGST/CGST'];
      }
      return (taxVatNo.substring(0, 2) == this.config.companyGSTINNumber.substring(0, 2) ? this.config.taxType['SGST/CGST'] : this.config.taxType['IGST'])
    }
    return this.config.taxType['None'];
  }

	getPermissions(){ return this.accessGroupListSubject.asObservable(); }
  get allcountryList() { return this.countryStoreData; }
  get allcurrencyList() { return this.currencyStoreData; }
  get alllanguageList() { return this.languageStoreData; }
  get allCompanyDetailList() { return this.companyDetailStoreData; }
  get allCustomersList() { return this.customerStoreData; }
  get allEmployeeList() { return this.employeeStoreData; }
  get allSupplierList() { return this.supplierStoreData }
}
